/**
 * 前端资源码统一配置。与后台权限资源配置对齐后，仅修改本文件即可全局生效。
 */
export const ResourceCode = {
  menu: {
    CENTRAL: 'CENTRAL',
    MAP_TOOL: 'MAP_TOOL',
    PLATFORM_PERMISSION: 'PLATFORM_PERMISSION',
    DEPT_TREE_QUERY: 'DEPT_TREE_QUERY',
    PERSONNEL_QUERY: 'PERSONNEL_QUERY',
    ROLE_QUERY: 'ROLE_QUERY',
    PERMISSION_PACKAGE_QUERY: 'PERMISSION_PACKAGE_QUERY',
    RESOURCE_QUERY: 'RESOURCE_QUERY',
    PERMISSION_OPERATION_LOG_QUERY: 'PERMISSION_OPERATION_LOG_QUERY',
    DEV_TOOL: 'DEV_TOOL',
    GENERAL_CONFIG: 'GENERAL_CONFIG',
    PDA_HOME_CONFIG: 'PDA_HOME_CONFIG',
    DRIVER_LEARNING_CENTER_CONFIG: 'DRIVER_LEARNING_CENTER_CONFIG',
    POD_CONFIG: 'POD_CONFIG',
    NODE_CONFIG: 'NODE_CONFIG',
    DEGRADE_MANAGEMENT: 'DEGRADE_MANAGEMENT',
    APP_VERSION: 'APP_VERSION',
    PERFORMANCE_MONITOR: 'PERFORMANCE_MONITOR',
    ADDRESS_LIBRARY: 'ADDRESS_LIBRARY',
    LOCATION_CORRECTION: 'LOCATION_CORRECTION',
    GEOFENCE_BLACKLIST_REVIEW: 'GEOFENCE_BLACKLIST_REVIEW',
    HUB_GEOFENCE_BLACKLIST: 'HUB_GEOFENCE_BLACKLIST',
    WHS_GEOFENCE_BLACKLIST: 'WHS_GEOFENCE_BLACKLIST',
    STANDARDIZED_ADDRESS: 'STANDARDIZED_ADDRESS',
    ADDRESS_LIFECYCLE: 'ADDRESS_LIFECYCLE',
    ADDRESS_WHITELIST: 'ADDRESS_WHITELIST',
    ADDRESS_KEYWORD_RULE: 'ADDRESS_KEYWORD_RULE',
    ADDRESS_BLACKLIST: 'ADDRESS_BLACKLIST',
    ADDRESS_INVALID: 'ADDRESS_INVALID',
    ADDRESS_RESIDENTIAL_AREA: 'ADDRESS_RESIDENTIAL_AREA',
    ADDRESS_RESIDENTIAL_AREA_PENDING: 'ADDRESS_RESIDENTIAL_AREA_PENDING',
    HUB_AB_ADDRESS_MANAGEMENT: 'HUB_AB_ADDRESS_MANAGEMENT',
    WHS_AB_ADDRESS_MANAGEMENT: 'WHS_AB_ADDRESS_MANAGEMENT',
    AB_ADDRESS_REVIEW: 'AB_ADDRESS_REVIEW',
    AB_ADDRESS_REVIEW_SUBMIT: 'AB_ADDRESS_REVIEW_SUBMIT',
    TRAJECTORY_PLATFORM: 'TRAJECTORY_PLATFORM',
    SETTLEMENT: 'SETTLEMENT',
    SETTLEMENT_CENTER: 'SETTLEMENT_CENTER',
    SETTLEMENT_CLEARING_VOUCHER: 'SETTLEMENT_CLEARING_VOUCHER',
    SETTLEMENT_ACCOUNT_MANAGEMENT: 'SETTLEMENT_ACCOUNT_MANAGEMENT',
    SETTLEMENT_BILL: 'SETTLEMENT_BILL',
    SETTLEMENT_PRICING_QUERY: 'SETTLEMENT_PRICING_QUERY',
    SETTLEMENT_PRICE_CENTER: 'SETTLEMENT_PRICE_CENTER',
    SETTLEMENT_REVIEW: 'SETTLEMENT_REVIEW',
    SETTLEMENT_ADJUSTMENT_REVIEW: 'SETTLEMENT_ADJUSTMENT_REVIEW',
    SETTLEMENT_FEE_ITEM_MANAGER: 'SETTLEMENT_FEE_ITEM_MANAGER',
    SETTLEMENT_REVISE: 'SETTLEMENT_REVISE',
    SETTLEMENT_PRICING_FAILURE_EXPORT: 'SETTLEMENT_PRICING_FAILURE_EXPORT',
    SETTLEMENT_PRE_BILL_REVISION: 'SETTLEMENT_PRE_BILL_REVISION',
    SETTLEMENT_FINANCE_STATISTICS: 'SETTLEMENT_FINANCE_STATISTICS',
    SETTLEMENT_REVENUE_REALTIME_STATISTICS: 'SETTLEMENT_REVENUE_REALTIME_STATISTICS',
    SETTLEMENT_DSP_EXPENSE_STATISTICS: 'SETTLEMENT_DSP_EXPENSE_STATISTICS',
    SETTLEMENT_REVENUE_BILLING_PERIOD_STATISTICS: 'SETTLEMENT_REVENUE_BILLING_PERIOD_STATISTICS',
    DATA_PLATFORM: 'DATA_PLATFORM',
    PDA_SCAN_CONFIG: 'PDA_SCAN_CONFIG',
    SYSTEM_OPERATION_LOG_QUERY: 'SYSTEM_OPERATION_LOG_QUERY',
    /** 下单配额管理（目录级，与后端 AppResource.ONBOARDING_ORDER_QUOTA 一致） */
    ONBOARDING_ORDER_QUOTA: 'ONBOARDING_ORDER_QUOTA',
    AOI_PLATFORM: 'AOI_PLATFORM',
    OPS_TOOL: 'OPS_TOOL',
    OPS_TOOL_SETTLEMENT: 'OPS_TOOL_SETTLEMENT',
    OPS_TOOL_PICKUP: 'OPS_TOOL_PICKUP',
    OPS_TOOL_WMS: 'OPS_TOOL_WMS',
    OPS_TOOL_TMS: 'OPS_TOOL_TMS',
    WMS_PLATFORM: 'WMS_PLATFORM',
    HUB_PROGRESS: 'HUB_PROGRESS',
    HUB_PROGRESS_OPERATION: 'HUB_PROGRESS_OPERATION',
    HUB_PROGRESS_WAREHOUSE: 'HUB_PROGRESS_WAREHOUSE',
    HUB_PROGRESS_DELIVERY: 'HUB_PROGRESS_DELIVERY',
    HUB_PROGRESS_TRACKING: 'HUB_PROGRESS_TRACKING',
    WHS_PROGRESS: 'WHS_PROGRESS',
    WHS_PROGRESS_DELIVERY: 'WHS_PROGRESS_DELIVERY',
    WHS_PROGRESS_TRACKING: 'WHS_PROGRESS_TRACKING',
    WHS_WORKBENCH: 'WHS_WORKBENCH',
    HUB_DAILY_REVIEW: 'HUB_DAILY_REVIEW',
    HUB_DASHBOARD: 'HUB_DASHBOARD',
    WHS_DASHBOARD: 'WHS_DASHBOARD',
    HUB_DASHBOARD_DELIVERY: 'HUB_DASHBOARD_DELIVERY',
    WHS_DASHBOARD_DELIVERY: 'WHS_DASHBOARD_DELIVERY',
    WHS_DELIVERY_MONITOR: 'WHS_DELIVERY_MONITOR',
    HUB_DASHBOARD_STALE: 'HUB_DASHBOARD_STALE',
    WHS_DASHBOARD_STALE: 'WHS_DASHBOARD_STALE',
    HUB_DASHBOARD_WAREHOUSE: 'HUB_DASHBOARD_WAREHOUSE',
    WHS_DELIVERY_DISPATCH: 'WHS_DELIVERY_DISPATCH',
    HUB_BAGGING_TASK: 'HUB_BAGGING_TASK',
    HUB_BAG_LABEL: 'HUB_BAG_LABEL',
    HUB_MASTER_BAG: 'HUB_MASTER_BAG',
    HUB_SORTER: 'HUB_SORTER',
    HUB_SORTER_SORT: 'HUB_SORTER_SORT',
    HUB_SORTER_PLAN: 'HUB_SORTER_PLAN',
    HUB_SORTER_LOG: 'HUB_SORTER_LOG',
    HUB_CUTOFF: 'HUB_CUTOFF',
    HUB_LABEL_REPRINT: 'HUB_LABEL_REPRINT',
    WHS_DELIVERY: 'WHS_DELIVERY',
    WHS_DELIVERY_ROUTE: 'WHS_DELIVERY_ROUTE',
    WHS_DELIVERY_ROUTE_HISTORY: 'WHS_DELIVERY_ROUTE_HISTORY',
    WHS_DELIVERY_ROUTE_REPLAY: 'WHS_DELIVERY_ROUTE_REPLAY',
    WHS_DELIVERY_TASK: 'WHS_DELIVERY_TASK',
    WHS_DELIVERY_DRIVER: 'WHS_DELIVERY_DRIVER',
    WHS_DELIVERY_DRIVER_BLACKLIST: 'WHS_DELIVERY_DRIVER_BLACKLIST',
    WHS_PENALTY_CENTER: 'WHS_PENALTY_CENTER',
    WHS_DOWNLOAD: 'WHS_DOWNLOAD',
    WHS_DOWNLOAD_VIEW_ALL: 'WHS_DOWNLOAD_VIEW_ALL',
    HUB_DOWNLOAD: 'HUB_DOWNLOAD',
    HUB_DOWNLOAD_VIEW_ALL: 'HUB_DOWNLOAD_VIEW_ALL',
    HUB_SITE_MANAGEMENT: 'HUB_SITE_MANAGEMENT',
    HUB_SITE_MANAGEMENT_EDIT: 'HUB_SITE_MANAGEMENT_EDIT',
    HUB_ACCOUNT: 'HUB_ACCOUNT',
    HUB_ACCOUNT_ACCOUNT: 'HUB_ACCOUNT_ACCOUNT',
    HUB_DSP_BILLING: 'HUB_DSP_BILLING',
    HUB_ACCOUNT_LABOR_TEAM: 'HUB_ACCOUNT_LABOR_TEAM',
    HUB_ACCOUNT_LABOR_TEAM_EDIT: 'HUB_ACCOUNT_LABOR_TEAM_EDIT',
    HUB_PACKAGE: 'HUB_PACKAGE',
    WHS_PACKAGE: 'WHS_PACKAGE',
    HUB_PACKAGE_DETAIL: 'HUB_PACKAGE_DETAIL',
    WHS_PACKAGE_DETAIL: 'WHS_PACKAGE_DETAIL',
    HUB_PACKAGE_SET_DELIVERY_STATUS: 'HUB_PACKAGE_SET_DELIVERY_STATUS',
    WMS_PACKAGE_SET_DELIVERY_STATUS: 'WMS_PACKAGE_SET_DELIVERY_STATUS',
    HUB_LABEL_SEARCH: 'HUB_LABEL_SEARCH',
    WHS_LABEL_SEARCH: 'WHS_LABEL_SEARCH',
    HUB_LABEL_SEARCH_DETAIL: 'HUB_LABEL_SEARCH_DETAIL',
    WHS_LABEL_SEARCH_DETAIL: 'WHS_LABEL_SEARCH_DETAIL',
    HUB_EXCEPTION: 'HUB_EXCEPTION',
    HUB_TT_EXCEPTION_ORDER_QUERY: 'HUB_TT_EXCEPTION_ORDER_QUERY',
    WHS_EXCEPTION: 'WHS_EXCEPTION',
    HUB_EXCEPTION_DETAIL: 'HUB_EXCEPTION_DETAIL',
    WHS_EXCEPTION_DETAIL: 'WHS_EXCEPTION_DETAIL',
    WHS_EXCEPTION_PACKAGE: 'WHS_EXCEPTION_PACKAGE',
    WHS_EXCEPTION_LOCATION: 'WHS_EXCEPTION_LOCATION',
    WHS_ISSUE_PARCEL_WORKBENCH: 'WHS_ISSUE_PARCEL_WORKBENCH',
    // 门牌免拍初审（仓管侧）：菜单入口 + 审核队列 + 初审操作
    WHS_POD_EXEMPT_REVIEW: 'WHS_POD_EXEMPT_REVIEW',
    SUPPORT_LOGIN: 'SUPPORT_LOGIN',
    SUPPORT_LOGIN_LOG: 'SUPPORT_LOGIN_LOG',
    SUPPORT_LOGIN_REDIS: 'SUPPORT_LOGIN_REDIS',
    SUPPORT_SCHEDULE_ORDER_POOL: 'SUPPORT_SCHEDULE_ORDER_POOL',
    SUPPORT_SCHEDULE_ROUTE_CACHE: 'SUPPORT_SCHEDULE_ROUTE_CACHE',
    SUPPORT_ORDER_ES: 'SUPPORT_ORDER_ES',
    SUPPORT_UPLOAD_TOOL: 'SUPPORT_UPLOAD_TOOL',
    TMS_PLATFORM: 'TMS_PLATFORM',
    TMS_TASK: 'TMS_TASK',
    TMS_TASK_DEPARTURE: 'TMS_TASK_DEPARTURE',
    TMS_TASK_ARRIVAL: 'TMS_TASK_ARRIVAL',
    TMS_ROUTE: 'TMS_ROUTE',
    TMS_TRANSIT: 'TMS_TRANSIT',
    TMS_SHIFT: 'TMS_SHIFT',
    TMS_STAFF: 'TMS_STAFF',
    TMS_VEHICLE: 'TMS_VEHICLE',
    TMS_DOWNLOAD: 'TMS_DOWNLOAD',
    PICKUP_PLATFORM: 'PICKUP_PLATFORM',
    PICKUP_APPOINTMENT: 'PICKUP_APPOINTMENT',
    PICKUP_APPOINTMENT_OPERATE: 'PICKUP_APPOINTMENT_OPERATE',
    PICKUP_PROGRESS: 'PICKUP_PROGRESS',
    PICKUP_TASK: 'PICKUP_TASK',
    PICKUP_TASK_OPERATE: 'PICKUP_TASK_OPERATE',
    PICKUP_DRIVER: 'PICKUP_DRIVER',
    PICKUP_VEHICLE: 'PICKUP_VEHICLE',
    PICKUP_SITE: 'PICKUP_SITE',
    PICKUP_PACKAGE: 'PICKUP_PACKAGE',
    PICKUP_DOWNLOAD: 'PICKUP_DOWNLOAD',
    PARTNER_CONTROL: 'PARTNER_CONTROL',
    PARTNER_PENALTY_REVIEW: 'PARTNER_PENALTY_REVIEW',
    PARTNER_PENALTY_GENERATION: 'PARTNER_PENALTY_GENERATION',
    PARTNER_PENALTY_APPEAL_REVIEW: 'PARTNER_PENALTY_APPEAL_REVIEW',
    PARTNER_CONTROL_DOWNLOAD: 'PARTNER_CONTROL_DOWNLOAD',
    PARTNER_PENALTY_CENTER: 'PARTNER_PENALTY_CENTER',
    // 司机活动：合作商管控（PARTNER_CONTROL）下的二级菜单，同时管司机活动的编辑/上下线
    DRIVER_ACTIVITY: 'DRIVER_ACTIVITY',
  },
  data: {
    DAILY_MEETING_DATA: 'DAILY_MEETING_DATA',
    SCALE_DATA: 'SCALE_DATA',
    PICKUP_DATA: 'PICKUP_DATA',
    SORTING_DATA: 'SORTING_DATA',
    TRANSPORTATION_DATA: 'TRANSPORTATION_DATA',
    DELIVERY_DATA_MENU: 'DELIVERY_DATA_MENU',
    DELIVERY_DATA: 'DELIVERY_DATA',
    QUALITY_DATA: 'QUALITY_DATA',
    AOI_PLATFORM: 'AOI_PLATFORM',
  },
  dashboard: {
    // 看板指标注释：按看板各自独立的写入门槛 / 编辑删除任意人门槛
    SCALE_ANNOTATION_WRITE: 'SCALE_ANNOTATION_WRITE',
    SCALE_ANNOTATION_ADMIN: 'SCALE_ANNOTATION_ADMIN',
    SORTING_ANNOTATION_WRITE: 'SORTING_ANNOTATION_WRITE',
    SORTING_ANNOTATION_ADMIN: 'SORTING_ANNOTATION_ADMIN',
    DELIVERY_ANNOTATION_WRITE: 'DELIVERY_ANNOTATION_WRITE',
    DELIVERY_ANNOTATION_ADMIN: 'DELIVERY_ANNOTATION_ADMIN',
    QUALITY_ANNOTATION_WRITE: 'QUALITY_ANNOTATION_WRITE',
    QUALITY_ANNOTATION_ADMIN: 'QUALITY_ANNOTATION_ADMIN',
    DAILY_MEETING_ATTRIBUTION_WRITE: 'DAILY_MEETING_ATTRIBUTION_WRITE',
    DAILY_MEETING_ATTRIBUTION_ADMIN: 'DAILY_MEETING_ATTRIBUTION_ADMIN',
  },
  dept: {
    ADD: 'DEPT_ADD',
    UPDATE: 'DEPT_UPDATE',
    DELETE: 'DEPT_DELETE',
    TRANSFER: 'DEPT_TRANSFER',
  },
  role: {
    ADD: 'ROLE_ADD',
    UPDATE: 'ROLE_UPDATE',
    DELETE: 'ROLE_DELETE',
  },
  personnel: {
    ADD: 'PERSONNEL_ADD',
    UPDATE: 'PERSONNEL_UPDATE',
    DELETE: 'PERSONNEL_DELETE',
  },
  permissionPackage: {
    ADD: 'PERMISSION_PACKAGE_ADD',
    UPDATE: 'PERMISSION_PACKAGE_UPDATE',
    DELETE: 'PERMISSION_PACKAGE_DELETE',
  },
  resource: {
    ADD: 'RESOURCE_ADD',
    UPDATE: 'RESOURCE_UPDATE',
    DELETE: 'RESOURCE_DELETE',
  },
  addressResidentialArea: {
    CREATE: 'ADDRESS_RESIDENTIAL_AREA_CREATE',
    UPDATE: 'ADDRESS_RESIDENTIAL_AREA_UPDATE',
    DELETE: 'ADDRESS_RESIDENTIAL_AREA_DELETE',
  },
  standardizedAddress: {
    BATCH_SAVE: 'STANDARDIZED_ADDRESS_BATCH_SAVE',
    UPDATE: 'STANDARDIZED_ADDRESS_UPDATE',
  },
  locationCorrection: {
    REVIEW_SUBMIT: 'REVIEW_SUBMIT',
  },
  addressCoordDedup: {
    VIEW: 'ADDRESS_COORD_DEDUP',
    START: 'ADDRESS_COORD_DEDUP_START',
    CANCEL: 'ADDRESS_COORD_DEDUP_CANCEL',
    ROLLBACK: 'ADDRESS_COORD_DEDUP_ROLLBACK',
  },
  addressWhitelist: {
    CREATE: 'ADDRESS_WHITELIST_CREATE',
    DELETE: 'ADDRESS_WHITELIST_DELETE',
  },
  addressWhitelistRule: {
    CREATE: 'ADDRESS_WHITELIST_RULE_CREATE',
    UPDATE: 'ADDRESS_WHITELIST_RULE_UPDATE',
    DELETE: 'ADDRESS_WHITELIST_RULE_DELETE',
  },
  addressKeywordRule: {
    CREATE: 'ADDRESS_KEYWORD_RULE_CREATE',
    UPDATE: 'ADDRESS_KEYWORD_RULE_UPDATE',
    DELETE: 'ADDRESS_KEYWORD_RULE_DELETE',
  },
  addressBlacklist: {
    DELETE: 'ADDRESS_BLACKLIST_DELETE',
  },
  zipcodeGeofence: {
    /** 黑名单围栏（WMS）审核，hub / warehouse 双码任一即可 */
    HUB_AUDIT: 'HUB_GEOFENCE_BLACKLIST_AUDIT',
    WHS_AUDIT: 'WHS_GEOFENCE_BLACKLIST_AUDIT',
  },
  addressInvalid: {
    DELETE: 'ADDRESS_INVALID_DELETE',
  },
  aoiPlatform: {
    /** 新增 / 修改 AOI 衍生属性 */
    UPSERT: 'AOI_PLATFORM_UPSERT',
  },
  settlement: {
    SETTLEMENT_REVENUE_CLEARING_VOUCHER: 'SETTLEMENT_REVENUE_CLEARING_VOUCHER',
    SETTLEMENT_COST_CLEARING_VOUCHER: 'SETTLEMENT_COST_CLEARING_VOUCHER',
    SETTLEMENT_REALTIME_TRANS_QUERY: 'SETTLEMENT_REALTIME_TRANS_QUERY',
    SETTLEMENT_REALTIME_ACCOUNT_STATEMENT: 'SETTLEMENT_REALTIME_ACCOUNT_STATEMENT',
    SETTLEMENT_REALTIME_BALANCE: 'SETTLEMENT_REALTIME_BALANCE',
    SETTLEMENT_REALTIME_EXPORT_DETAIL: 'SETTLEMENT_REALTIME_EXPORT_DETAIL',
    SETTLEMENT_REVENUE_BILL_CHECK: 'SETTLEMENT_REVENUE_BILL_CHECK',
    SETTLEMENT_REVENUE_BILL_OPERATE: 'SETTLEMENT_REVENUE_BILL_OPERATE',
    SETTLEMENT_COST_BILL_CHECK: 'SETTLEMENT_COST_BILL_CHECK',
    SETTLEMENT_COST_BILL_OPERATE: 'SETTLEMENT_COST_BILL_OPERATE',
    SETTLEMENT_DSP_BILL_INVOICE_CONFIRM: 'SETTLEMENT_DSP_BILL_INVOICE_CONFIRM',
    SETTLEMENT_DSP_BILL_PAYMENT: 'SETTLEMENT_DSP_BILL_PAYMENT',
    SETTLEMENT_REVENUE_PRICING_QUERY: 'SETTLEMENT_REVENUE_PRICING_QUERY',
    SETTLEMENT_COST_PRICING_QUERY: 'SETTLEMENT_COST_PRICING_QUERY',
    SETTLEMENT_REVENUE_PRICE_PLAN_CHECK: 'SETTLEMENT_REVENUE_PRICE_PLAN_CHECK',
    SETTLEMENT_REVENUE_PRICE_PLAN_OPERATE: 'SETTLEMENT_REVENUE_PRICE_PLAN_OPERATE',
    SETTLEMENT_REVENUE_PRICE_APPLY_CHECK: 'SETTLEMENT_REVENUE_PRICE_APPLY_CHECK',
    SETTLEMENT_REVENUE_PRICE_APPLY_OPERATE: 'SETTLEMENT_REVENUE_PRICE_APPLY_OPERATE',
    SETTLEMENT_COST_PRICE_PLAN_CHECK: 'SETTLEMENT_COST_PRICE_PLAN_CHECK',
    SETTLEMENT_COST_PRICE_PLAN_OPERATE: 'SETTLEMENT_COST_PRICE_PLAN_OPERATE',
    SETTLEMENT_COST_PRICE_APPLY_CHECK: 'SETTLEMENT_COST_PRICE_APPLY_CHECK',
    SETTLEMENT_COST_PRICE_APPLY_OPERATE: 'SETTLEMENT_COST_PRICE_APPLY_OPERATE',
    SETTLEMENT_COST_PERIODIC_PRICE_PLAN_CHECK: 'SETTLEMENT_COST_PERIODIC_PRICE_PLAN_CHECK',
    SETTLEMENT_COST_PERIODIC_PRICE_PLAN_OPERATE: 'SETTLEMENT_COST_PERIODIC_PRICE_PLAN_OPERATE',
    SETTLEMENT_COST_PERIODIC_PRICE_APPLY_CHECK: 'SETTLEMENT_COST_PERIODIC_PRICE_APPLY_CHECK',
    SETTLEMENT_COST_PERIODIC_PRICE_APPLY_OPERATE: 'SETTLEMENT_COST_PERIODIC_PRICE_APPLY_OPERATE',
    SETTLEMENT_REVENUE_PRICING_FAILURE_EXPORT: 'SETTLEMENT_REVENUE_PRICING_FAILURE_EXPORT',
    SETTLEMENT_COST_PRICING_FAILURE_EXPORT: 'SETTLEMENT_COST_PRICING_FAILURE_EXPORT',
    SETTLEMENT_REVENUE_PRICING_FAILURE_EXPORT_OPERATE: 'SETTLEMENT_REVENUE_PRICING_FAILURE_EXPORT_OPERATE',
    SETTLEMENT_COST_PRICING_FAILURE_EXPORT_OPERATE: 'SETTLEMENT_COST_PRICING_FAILURE_EXPORT_OPERATE',
    SETTLEMENT_REVENUE_PRE_BILL_REVISION: 'SETTLEMENT_REVENUE_PRE_BILL_REVISION',
    SETTLEMENT_COST_PRE_BILL_REVISION: 'SETTLEMENT_COST_PRE_BILL_REVISION',
    SETTLEMENT_REVENUE_PRE_BILL_REVISION_OPERATE: 'SETTLEMENT_REVENUE_PRE_BILL_REVISION_OPERATE',
    SETTLEMENT_COST_PRE_BILL_REVISION_OPERATE: 'SETTLEMENT_COST_PRE_BILL_REVISION_OPERATE',
    SETTLEMENT_REVENUE_REALTIME_ESTIMATED: 'SETTLEMENT_REVENUE_REALTIME_ESTIMATED',
    SETTLEMENT_REVENUE_REALTIME_BUSINESS: 'SETTLEMENT_REVENUE_REALTIME_BUSINESS',
    SETTLEMENT_REVENUE_REALTIME_RECEIVABLE: 'SETTLEMENT_REVENUE_REALTIME_RECEIVABLE',
    SETTLEMENT_REVENUE_BILLING_PERIOD_ESTIMATED: 'SETTLEMENT_REVENUE_BILLING_PERIOD_ESTIMATED',
    SETTLEMENT_REVENUE_BILLING_PERIOD_RECEIVABLE: 'SETTLEMENT_REVENUE_BILLING_PERIOD_RECEIVABLE',
    SETTLEMENT_REALTIME_SNAPSHOT: 'SETTLEMENT_REALTIME_SNAPSHOT',
    SETTLEMENT_COST_DETAIL_ADJUSTMENT: 'SETTLEMENT_COST_DETAIL_ADJUSTMENT',
  },
  dsp: {
    // DSP 财务档案：查看（税号、银行账号为掩码值）
    DSP_FINANCE_INFO: 'DSP_FINANCE_INFO',
    // DSP 财务档案：编辑保存（同时决定税号、银行账号是否返回全量值）
    DSP_FINANCE_INFO_OPERATE: 'DSP_FINANCE_INFO_OPERATE',
  },
  /**
   * 客服系统（CS/QC/RC 合并菜单）。字面量须与后端 AppResource.kt 的 CS_ 区块完全一致。
   * 菜单码只控前端可见性，接口鉴权以后端 @RequireResource 为准。
   */
  cs: {
    // 一级菜单可见性门槛，仅前端使用
    CS_PLATFORM: 'CS_PLATFORM',
    CS_DRIVER_REVIEW: 'CS_DRIVER_REVIEW',
    // 结算审核二级菜单门槛，仅前端使用；数据权限点是 CS_SETTLEMENT_PROCESS_REVIEW
    CS_SETTLEMENT_REVIEW: 'CS_SETTLEMENT_REVIEW',
    CS_SETTLEMENT_PROCESS_REVIEW: 'CS_SETTLEMENT_PROCESS_REVIEW',
    CS_QC_UPLOAD: 'CS_QC_UPLOAD',
    // 包裹查询：CS_PACKAGE 落全量查询页（多维筛选 + 批量导出），CS_PACKAGE_LITE 落轻量查看页；两码共用一个菜单入口
    CS_PACKAGE: 'CS_PACKAGE',
    CS_PACKAGE_LITE: 'CS_PACKAGE_LITE',
    CS_EXCEPTION: 'CS_EXCEPTION',
    CS_POD_REVIEW: 'CS_POD_REVIEW',
    // DSP 申诉审核：菜单入口与查询/导出用 CS_DSP_APPEAL_REVIEW，提交审核结论用 CS_DSP_APPEAL_REVIEW_OPERATE
    CS_DSP_APPEAL_REVIEW: 'CS_DSP_APPEAL_REVIEW',
    CS_DSP_APPEAL_REVIEW_OPERATE: 'CS_DSP_APPEAL_REVIEW_OPERATE',
    CS_DSP_APPEAL_SUMMARY: 'CS_DSP_APPEAL_SUMMARY',
    // 揽收 POP 审核：查看与操作分权
    CS_POP_REVIEW: 'CS_POP_REVIEW',
    CS_POP_REVIEW_OPERATE: 'CS_POP_REVIEW_OPERATE',
    // 舆情 POD 审核：无只读角色，查看与操作同码
    CS_POD_RISK_REVIEW: 'CS_POD_RISK_REVIEW',
    CS_EXEMPT_SPOT_CHECK: 'CS_EXEMPT_SPOT_CHECK',
    CS_POD_EXEMPT_REVIEW: 'CS_POD_EXEMPT_REVIEW',
    CS_POD_EXEMPT_DICT: 'CS_POD_EXEMPT_DICT',
    CS_UNDELIVERABLE_UPLOAD: 'CS_UNDELIVERABLE_UPLOAD',
    CS_DOWNLOAD: 'CS_DOWNLOAD',
  },
  /**
   * CRM 客户管理页（/central/channels）。
   * 需求：客户管理平台权限拆分 & 开户流程优化（2026-09-16），替代原 isFinancialTeam / canManageChannelSettlement 等角色硬编码。
   * 管理员账号 / 运营账号四个操作按角色分码，后端 CustomerManagementMutation 会按目标账号角色二次校验。
   */
  crm: {
    CRM_CHANNEL: 'CRM_CHANNEL',
    CRM_CHANNEL_CREATE: 'CRM_CHANNEL_CREATE',
    CRM_CHANNEL_FILTER: 'CRM_CHANNEL_FILTER',
    CRM_CHANNEL_VIEW: 'CRM_CHANNEL_VIEW',
    CRM_CHANNEL_EDIT: 'CRM_CHANNEL_EDIT',
    CRM_CHANNEL_TAB_BASIC: 'CRM_CHANNEL_TAB_BASIC',
    CRM_CHANNEL_TAB_SETTLEMENT: 'CRM_CHANNEL_TAB_SETTLEMENT',
    CRM_CHANNEL_TAB_CONTACT: 'CRM_CHANNEL_TAB_CONTACT',
    CRM_CHANNEL_TAB_FULFILLMENT: 'CRM_CHANNEL_TAB_FULFILLMENT',
    CRM_CHANNEL_FILE_UPLOAD: 'CRM_CHANNEL_FILE_UPLOAD',
    CRM_CHANNEL_FILE_DELETE: 'CRM_CHANNEL_FILE_DELETE',
    CRM_CHANNEL_FILE_DOWNLOAD: 'CRM_CHANNEL_FILE_DOWNLOAD',
    CRM_CHANNEL_FINANCE_CONTACT_ADD: 'CRM_CHANNEL_FINANCE_CONTACT_ADD',
    CRM_CHANNEL_FINANCE_CONTACT_DELETE: 'CRM_CHANNEL_FINANCE_CONTACT_DELETE',
    CRM_CHANNEL_SEND_KEY: 'CRM_CHANNEL_SEND_KEY',
    CRM_CHANNEL_CUSTOMER_ACCOUNT: 'CRM_CHANNEL_CUSTOMER_ACCOUNT',
    CRM_CHANNEL_CUSTOMER_LOG: 'CRM_CHANNEL_CUSTOMER_LOG',
    CRM_CHANNEL_ADMIN_ACCOUNT_CREATE: 'CRM_CHANNEL_ADMIN_ACCOUNT_CREATE',
    CRM_CHANNEL_ADMIN_ACCOUNT_DELETE: 'CRM_CHANNEL_ADMIN_ACCOUNT_DELETE',
    CRM_CHANNEL_ADMIN_ACCOUNT_RESET_PASSWORD: 'CRM_CHANNEL_ADMIN_ACCOUNT_RESET_PASSWORD',
    CRM_CHANNEL_ADMIN_ACCOUNT_SEND_EMAIL: 'CRM_CHANNEL_ADMIN_ACCOUNT_SEND_EMAIL',
    CRM_CHANNEL_OPERATOR_ACCOUNT_CREATE: 'CRM_CHANNEL_OPERATOR_ACCOUNT_CREATE',
    CRM_CHANNEL_OPERATOR_ACCOUNT_DELETE: 'CRM_CHANNEL_OPERATOR_ACCOUNT_DELETE',
    CRM_CHANNEL_OPERATOR_ACCOUNT_RESET_PASSWORD: 'CRM_CHANNEL_OPERATOR_ACCOUNT_RESET_PASSWORD',
    CRM_CHANNEL_OPERATOR_ACCOUNT_SEND_EMAIL: 'CRM_CHANNEL_OPERATOR_ACCOUNT_SEND_EMAIL',
  },
} as const;
